/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AdditionalComments } from './AdditionalComments';
import {
    AdditionalCommentsFromJSON,
    AdditionalCommentsFromJSONTyped,
    AdditionalCommentsToJSON,
} from './AdditionalComments';
import type { AiExtractionId } from './AiExtractionId';
import {
    AiExtractionIdFromJSON,
    AiExtractionIdFromJSONTyped,
    AiExtractionIdToJSON,
} from './AiExtractionId';
import type { BrokerageRegionIdentifier } from './BrokerageRegionIdentifier';
import {
    BrokerageRegionIdentifierFromJSON,
    BrokerageRegionIdentifierFromJSONTyped,
    BrokerageRegionIdentifierToJSON,
} from './BrokerageRegionIdentifier';
import type { BuyerRepresentation } from './BuyerRepresentation';
import {
    BuyerRepresentationFromJSON,
    BuyerRepresentationFromJSONTyped,
    BuyerRepresentationToJSON,
} from './BuyerRepresentation';
import type { Contact } from './Contact';
import {
    ContactFromJSON,
    ContactFromJSONTyped,
    ContactToJSON,
} from './Contact';
import type { HelpscoutLink } from './HelpscoutLink';
import {
    HelpscoutLinkFromJSON,
    HelpscoutLinkFromJSONTyped,
    HelpscoutLinkToJSON,
} from './HelpscoutLink';
import type { ManualEntryReason1 } from './ManualEntryReason1';
import {
    ManualEntryReason1FromJSON,
    ManualEntryReason1FromJSONTyped,
    ManualEntryReason1ToJSON,
} from './ManualEntryReason1';
import type { MlsId } from './MlsId';
import {
    MlsIdFromJSON,
    MlsIdFromJSONTyped,
    MlsIdToJSON,
} from './MlsId';
import type { OfferBuyerAgent } from './OfferBuyerAgent';
import {
    OfferBuyerAgentFromJSON,
    OfferBuyerAgentFromJSONTyped,
    OfferBuyerAgentToJSON,
} from './OfferBuyerAgent';
import type { OfferLcep } from './OfferLcep';
import {
    OfferLcepFromJSON,
    OfferLcepFromJSONTyped,
    OfferLcepToJSON,
} from './OfferLcep';
import type { OfferNote } from './OfferNote';
import {
    OfferNoteFromJSON,
    OfferNoteFromJSONTyped,
    OfferNoteToJSON,
} from './OfferNote';
import type { OfferOfferTerminationReason } from './OfferOfferTerminationReason';
import {
    OfferOfferTerminationReasonFromJSON,
    OfferOfferTerminationReasonFromJSONTyped,
    OfferOfferTerminationReasonToJSON,
} from './OfferOfferTerminationReason';
import type { OfferStatus } from './OfferStatus';
import {
    OfferStatusFromJSON,
    OfferStatusFromJSONTyped,
    OfferStatusToJSON,
} from './OfferStatus';
import type { OfferSubmissionDocument } from './OfferSubmissionDocument';
import {
    OfferSubmissionDocumentFromJSON,
    OfferSubmissionDocumentFromJSONTyped,
    OfferSubmissionDocumentToJSON,
} from './OfferSubmissionDocument';
import type { OfferTerminationNotes } from './OfferTerminationNotes';
import {
    OfferTerminationNotesFromJSON,
    OfferTerminationNotesFromJSONTyped,
    OfferTerminationNotesToJSON,
} from './OfferTerminationNotes';
import type { OfferTerms } from './OfferTerms';
import {
    OfferTermsFromJSON,
    OfferTermsFromJSONTyped,
    OfferTermsToJSON,
} from './OfferTerms';
import type { PartnerDecision } from './PartnerDecision';
import {
    PartnerDecisionFromJSON,
    PartnerDecisionFromJSONTyped,
    PartnerDecisionToJSON,
} from './PartnerDecision';
import type { PinnedAt } from './PinnedAt';
import {
    PinnedAtFromJSON,
    PinnedAtFromJSONTyped,
    PinnedAtToJSON,
} from './PinnedAt';
import type { ReceivedAt } from './ReceivedAt';
import {
    ReceivedAtFromJSON,
    ReceivedAtFromJSONTyped,
    ReceivedAtToJSON,
} from './ReceivedAt';
import type { SellerName } from './SellerName';
import {
    SellerNameFromJSON,
    SellerNameFromJSONTyped,
    SellerNameToJSON,
} from './SellerName';
import type { StatusReason } from './StatusReason';
import {
    StatusReasonFromJSON,
    StatusReasonFromJSONTyped,
    StatusReasonToJSON,
} from './StatusReason';

/**
 * 
 * @export
 * @interface Offer
 */
export interface Offer {
    /**
     * 
     * @type {string}
     * @memberof Offer
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Offer
     */
    listingId: string;
    /**
     * 
     * @type {OfferLcep}
     * @memberof Offer
     */
    lcep?: OfferLcep;
    /**
     * 
     * @type {string}
     * @memberof Offer
     */
    addressStr: string;
    /**
     * 
     * @type {BrokerageRegionIdentifier}
     * @memberof Offer
     */
    brokerageRegionIdentifier?: BrokerageRegionIdentifier;
    /**
     * 
     * @type {MlsId}
     * @memberof Offer
     */
    mlsId?: MlsId;
    /**
     * 
     * @type {Contact}
     * @memberof Offer
     */
    buyer: Contact;
    /**
     * 
     * @type {OfferBuyerAgent}
     * @memberof Offer
     */
    buyerAgent?: OfferBuyerAgent;
    /**
     * 
     * @type {BuyerRepresentation}
     * @memberof Offer
     */
    buyerRepresentation: BuyerRepresentation;
    /**
     * 
     * @type {SellerName}
     * @memberof Offer
     */
    sellerName?: SellerName;
    /**
     * 
     * @type {AdditionalComments}
     * @memberof Offer
     */
    additionalComments?: AdditionalComments;
    /**
     * 
     * @type {HelpscoutLink}
     * @memberof Offer
     */
    helpscoutLink?: HelpscoutLink;
    /**
     * 
     * @type {OfferStatus}
     * @memberof Offer
     */
    status: OfferStatus;
    /**
     * 
     * @type {OfferOfferTerminationReason}
     * @memberof Offer
     */
    offerTerminationReason?: OfferOfferTerminationReason;
    /**
     * 
     * @type {OfferTerminationNotes}
     * @memberof Offer
     */
    offerTerminationNotes?: OfferTerminationNotes;
    /**
     * 
     * @type {StatusReason}
     * @memberof Offer
     */
    statusReason?: StatusReason;
    /**
     * 
     * @type {boolean}
     * @memberof Offer
     */
    isBackup?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Offer
     */
    isBestOffer?: boolean;
    /**
     * 
     * @type {OfferLcep}
     * @memberof Offer
     */
    createdBy?: OfferLcep;
    /**
     * 
     * @type {ReceivedAt}
     * @memberof Offer
     */
    receivedAt?: ReceivedAt;
    /**
     * 
     * @type {PinnedAt}
     * @memberof Offer
     */
    pinnedAt?: PinnedAt;
    /**
     * 
     * @type {Date}
     * @memberof Offer
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Offer
     */
    updatedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof Offer
     */
    counterOffersCount?: number;
    /**
     * 
     * @type {Array<OfferNote>}
     * @memberof Offer
     */
    notes?: Array<OfferNote>;
    /**
     * 
     * @type {Array<OfferTerms>}
     * @memberof Offer
     */
    terms?: Array<OfferTerms>;
    /**
     * 
     * @type {Array<OfferSubmissionDocument>}
     * @memberof Offer
     */
    submissionDocuments?: Array<OfferSubmissionDocument>;
    /**
     * 
     * @type {ManualEntryReason1}
     * @memberof Offer
     */
    manualEntryReason?: ManualEntryReason1;
    /**
     * 
     * @type {AiExtractionId}
     * @memberof Offer
     */
    aiExtractionId?: AiExtractionId;
    /**
     * 
     * @type {PartnerDecision}
     * @memberof Offer
     */
    partnerDecision?: PartnerDecision;
    /**
     * 
     * @type {Date}
     * @memberof Offer
     */
    partnerDecisionAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof Offer
     */
    partnerDecisionNotes?: string;
    /**
     * 
     * @type {string}
     * @memberof Offer
     */
    buyerAgentNote?: string;
    /**
     * Check if offer is stale (older than threshold and still new)
     * @type {boolean}
     * @memberof Offer
     */
    readonly stale: boolean;
}

/**
 * Check if a given object implements the Offer interface.
 */
export function instanceOfOffer(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "listingId" in value;
    isInstance = isInstance && "addressStr" in value;
    isInstance = isInstance && "buyer" in value;
    isInstance = isInstance && "buyerRepresentation" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "updatedAt" in value;
    isInstance = isInstance && "stale" in value;

    return isInstance;
}

export function OfferFromJSON(json: any): Offer {
    return OfferFromJSONTyped(json, false);
}

export function OfferFromJSONTyped(json: any, ignoreDiscriminator: boolean): Offer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'listingId': json['listing_id'],
        'lcep': !exists(json, 'lcep') ? undefined : OfferLcepFromJSON(json['lcep']),
        'addressStr': json['address_str'],
        'brokerageRegionIdentifier': !exists(json, 'brokerage_region_identifier') ? undefined : BrokerageRegionIdentifierFromJSON(json['brokerage_region_identifier']),
        'mlsId': !exists(json, 'mls_id') ? undefined : MlsIdFromJSON(json['mls_id']),
        'buyer': ContactFromJSON(json['buyer']),
        'buyerAgent': !exists(json, 'buyer_agent') ? undefined : OfferBuyerAgentFromJSON(json['buyer_agent']),
        'buyerRepresentation': BuyerRepresentationFromJSON(json['buyer_representation']),
        'sellerName': !exists(json, 'seller_name') ? undefined : SellerNameFromJSON(json['seller_name']),
        'additionalComments': !exists(json, 'additional_comments') ? undefined : AdditionalCommentsFromJSON(json['additional_comments']),
        'helpscoutLink': !exists(json, 'helpscout_link') ? undefined : HelpscoutLinkFromJSON(json['helpscout_link']),
        'status': OfferStatusFromJSON(json['status']),
        'offerTerminationReason': !exists(json, 'offer_termination_reason') ? undefined : OfferOfferTerminationReasonFromJSON(json['offer_termination_reason']),
        'offerTerminationNotes': !exists(json, 'offer_termination_notes') ? undefined : OfferTerminationNotesFromJSON(json['offer_termination_notes']),
        'statusReason': !exists(json, 'status_reason') ? undefined : StatusReasonFromJSON(json['status_reason']),
        'isBackup': !exists(json, 'is_backup') ? undefined : json['is_backup'],
        'isBestOffer': !exists(json, 'is_best_offer') ? undefined : json['is_best_offer'],
        'createdBy': !exists(json, 'created_by') ? undefined : OfferLcepFromJSON(json['created_by']),
        'receivedAt': !exists(json, 'received_at') ? undefined : ReceivedAtFromJSON(json['received_at']),
        'pinnedAt': !exists(json, 'pinned_at') ? undefined : PinnedAtFromJSON(json['pinned_at']),
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
        'counterOffersCount': !exists(json, 'counter_offers_count') ? undefined : json['counter_offers_count'],
        'notes': !exists(json, 'notes') ? undefined : ((json['notes'] as Array<any>).map(OfferNoteFromJSON)),
        'terms': !exists(json, 'terms') ? undefined : ((json['terms'] as Array<any>).map(OfferTermsFromJSON)),
        'submissionDocuments': !exists(json, 'submission_documents') ? undefined : ((json['submission_documents'] as Array<any>).map(OfferSubmissionDocumentFromJSON)),
        'manualEntryReason': !exists(json, 'manual_entry_reason') ? undefined : ManualEntryReason1FromJSON(json['manual_entry_reason']),
        'aiExtractionId': !exists(json, 'ai_extraction_id') ? undefined : AiExtractionIdFromJSON(json['ai_extraction_id']),
        'partnerDecision': !exists(json, 'partner_decision') ? undefined : PartnerDecisionFromJSON(json['partner_decision']),
        'partnerDecisionAt': !exists(json, 'partner_decision_at') ? undefined : (new Date(json['partner_decision_at'])),
        'partnerDecisionNotes': !exists(json, 'partner_decision_notes') ? undefined : json['partner_decision_notes'],
        'buyerAgentNote': !exists(json, 'buyer_agent_note') ? undefined : json['buyer_agent_note'],
        'stale': json['stale'],
    };
}

export function OfferToJSON(value?: Offer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'listing_id': value.listingId,
        'lcep': OfferLcepToJSON(value.lcep),
        'address_str': value.addressStr,
        'brokerage_region_identifier': BrokerageRegionIdentifierToJSON(value.brokerageRegionIdentifier),
        'mls_id': MlsIdToJSON(value.mlsId),
        'buyer': ContactToJSON(value.buyer),
        'buyer_agent': OfferBuyerAgentToJSON(value.buyerAgent),
        'buyer_representation': BuyerRepresentationToJSON(value.buyerRepresentation),
        'seller_name': SellerNameToJSON(value.sellerName),
        'additional_comments': AdditionalCommentsToJSON(value.additionalComments),
        'helpscout_link': HelpscoutLinkToJSON(value.helpscoutLink),
        'status': OfferStatusToJSON(value.status),
        'offer_termination_reason': OfferOfferTerminationReasonToJSON(value.offerTerminationReason),
        'offer_termination_notes': OfferTerminationNotesToJSON(value.offerTerminationNotes),
        'status_reason': StatusReasonToJSON(value.statusReason),
        'is_backup': value.isBackup,
        'is_best_offer': value.isBestOffer,
        'created_by': OfferLcepToJSON(value.createdBy),
        'received_at': ReceivedAtToJSON(value.receivedAt),
        'pinned_at': PinnedAtToJSON(value.pinnedAt),
        'created_at': (value.createdAt.toISOString()),
        'updated_at': (value.updatedAt.toISOString()),
        'counter_offers_count': value.counterOffersCount,
        'notes': value.notes === undefined ? undefined : ((value.notes as Array<any>).map(OfferNoteToJSON)),
        'terms': value.terms === undefined ? undefined : ((value.terms as Array<any>).map(OfferTermsToJSON)),
        'submission_documents': value.submissionDocuments === undefined ? undefined : ((value.submissionDocuments as Array<any>).map(OfferSubmissionDocumentToJSON)),
        'manual_entry_reason': ManualEntryReason1ToJSON(value.manualEntryReason),
        'ai_extraction_id': AiExtractionIdToJSON(value.aiExtractionId),
        'partner_decision': PartnerDecisionToJSON(value.partnerDecision),
        'partner_decision_at': value.partnerDecisionAt === undefined ? undefined : (value.partnerDecisionAt.toISOString()),
        'partner_decision_notes': value.partnerDecisionNotes,
        'buyer_agent_note': value.buyerAgentNote,
    };
}

